export default __webpack_public_path__ + "static/media/schenkerlogo.3dfddce1.png";